<template>
  <div class="cookie-bar">
    <a
      class="cookie-bar__content"
      href="http://privacy.gucci.com/"
      target="_blank"
      rel="noopener noreferrer"
      v-html="$translate('cookies')"
    />
  </div>
</template>

<script>
export default {
  name: 'CookieBar',
};
</script>

<style lang="scss" scoped>
.cookie-bar {
  position: fixed;
  bottom: 25px;
  left: 0;
  width: 100%;

  color: inherit;
  text-align: center;
  color: $color-yellow;
  font-size: 12px;

  pointer-events: none;

  @include mq(ipadP) {
    font-size: 14px;
  }

  &__content {
    pointer-events: auto;
  }
}
</style>
